export default __webpack_public_path__ + "img/alfa-romeo-logo.b7568a98.png";